import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { RoomSelectComponent } from './room-select.component';
import { ClickOutsideModule } from '../../directives/click-outside/click-outside.module';
import { IconSvgComponent } from '../icon/icon.component';
import { RxButtonModule } from '../button/button.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RxButtonModule,
    ClickOutsideModule,
    IconSvgComponent,
  ],
  declarations: [RoomSelectComponent],
  exports: [RoomSelectComponent],
})
export class RxRoomSelectModule {}
